// extracted by mini-css-extract-plugin
module.exports = {"headinglarge":"PageNotFound_headinglarge_14lo_","textlarge":"PageNotFound_textlarge_3rh0X","centered":"PageNotFound_centered_44nU3"};